import VoicesAudio from '@js/sharable/VoicesAudio';

window.bootstrap = require('@bootstrap/dist/js/bootstrap.bundle');
require('@js/utilities/polyfills/safari-focus-polyfill');
require('@js/sharable/VoicesAudio');
require('@js/sharable/voicesHeader');
require('@js/sharable/voicesFooter');
require('../scripts/components/banner');
import initializeTooltips from '@js/sharable/bootstrapHandlers/tooltips';
const Flyout = require('@js/sharable/Flyout');
const { buttonSend, buttonReturn, buttonReturnSuccess } = require('@js/sharable/buttonSend');

window.buttonSend = buttonSend;
window.buttonReturn = buttonReturn;
window.buttonReturnSuccess = buttonReturnSuccess;

/**
 * VoicesTheme Class.
 */
class VoicesTheme {
    /**
     * Initializes VoicesTheme
     */
    constructor() {
        initializeTooltips();
        this.handleModals();
        this.handleLazyLoading();
        this.setMinHeightForMainPage();
        this.unfocusDropdownButton();
        this.initializeCollapseElements();
        this.addDropdownAnimations();
        this.preventTypingOnReadonlyElements();

        VoicesAudio.initializeAll();

        new Flyout();
    }

    handleLazyLoading() {
        if ('IntersectionObserver' in window) {
            const lazyloadImages = document.querySelectorAll('.lazy');

            const imageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        image.src = image.dataset.src;

                        image.classList.remove('lazy');
                        imageObserver.unobserve(image);
                    }
                });
            });

            lazyloadImages.forEach(function(image) {
                imageObserver.observe(image);
            });
        } else {
            let lazyloadThrottleTimeout;
            const lazyloadImages = document.querySelectorAll('.lazy');

            function lazyload() {
                if (lazyloadThrottleTimeout) {
                    clearTimeout(lazyloadThrottleTimeout);
                }

                lazyloadThrottleTimeout = setTimeout(function() {
                    var scrollTop = window.pageYOffset;
                    lazyloadImages.forEach(function(img) {
                        if (img.offsetTop < (window.innerHeight + scrollTop)) {
                            img.src = img.dataset.src;
                            img.classList.remove('lazy');
                        }
                    });
                    if (lazyloadImages.length === 0) {
                        document.removeEventListener('scroll', lazyload);
                        window.removeEventListener('resize', lazyload);
                        window.removeEventListener('orientationChange', lazyload);
                    }
                }, 20);
            }

            document.addEventListener('scroll', lazyload);
            window.addEventListener('resize', lazyload);
            window.addEventListener('orientationChange', lazyload);
        }
    }

    /**
     * Initializes modals with the class 'modal-autoload' and shows them.
     */
    handleModals() {
        const autoloadModals = document.querySelectorAll('.modal.modal-autoload');
        autoloadModals.forEach(modal => {
            const modalInstance = bootstrap.Modal.getOrCreateInstance(modal);
            modalInstance.show();
        });

        document.querySelectorAll('.modal').forEach(modal => {
            modal.addEventListener('show.bs.modal', () => {
                if (document.querySelectorAll('.modal-backdrop').length > -1) {
                    document.querySelectorAll('.modal-backdrop:not(:first-of-type)').forEach(backdrop => backdrop.remove());
                }
            });

            modal.addEventListener('hide.bs.modal', () => {
                if (document.querySelectorAll('.modal-backdrop').length >= 1) {
                    document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
                }
            });
        });
    }

    /**
     * Sets the minimum height for the main page content to fill the screen.
     */
    setMinHeightForMainPage() {
        const mainPage = document.getElementById('main-page');
        if (mainPage) {
            const footerHeight = document.querySelector('footer')?.offsetHeight || 0;
            const headerHeight = document.querySelector('header')?.offsetHeight || 0;
            mainPage.style.minHeight = (window.innerHeight - footerHeight - headerHeight) + 'px';
        }
    }

    /**
     * Removes focus from dropdown buttons after they are clicked.
     */
    unfocusDropdownButton() {
        const dropdownButtons = document.querySelectorAll('.dropdown > button');
        dropdownButtons.forEach(dropdownButton => {
            dropdownButton.addEventListener('click', () => {
                const dropdownMenu = dropdownButton.nextElementSibling;
                if (dropdownMenu.style.display === 'none') {
                    dropdownButton.blur();
                }
            });
        });
    }

    /**
     * Handles Bootstrap collapse elements to toggle text between collapsed and expanded states.
     */
    initializeCollapseElements() {
        const collapseElements = document.querySelectorAll('[data-bs-toggle="collapse"]');
        collapseElements.forEach(collapseElement => {
            collapseElement.addEventListener('click', () => {
                const hasCollapsed = collapseElement.getAttribute('aria-expanded') === 'false';
                const collapseText = collapseElement.getAttribute('data-collapse-text') || null;
                const collapsedText = collapseElement.getAttribute('data-collapsed-text') || null;
                if (collapseText && collapsedText) {
                    collapseElement.innerText = hasCollapsed ? collapsedText : collapseText;
                }
            });
        });
    }

    /**
     * Adds slideDown and slideUp animations to Bootstrap dropdown menus.
     */
    addDropdownAnimations() {
        const dropdowns = document.querySelectorAll('.dropdown');
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('show.bs.dropdown', () => {
                const dropdownMenu = dropdown.querySelector('.dropdown-menu');
                dropdownMenu.style.display = 'none';
                dropdownMenu.style.display = 'block';
                dropdownMenu.style.height = 'auto';
                const height = dropdownMenu.clientHeight + 'px';
                dropdownMenu.style.height = '0';
                dropdownMenu.style.transition = 'height 0.35s ease';
                dropdownMenu.style.height = height;
                dropdownMenu.style.transition = '';
            });

            dropdown.addEventListener('hide.bs.dropdown', () => {
                const dropdownMenu = dropdown.querySelector('.dropdown-menu');
                dropdownMenu.style.transition = 'height 0.35s ease';
                dropdownMenu.style.height = '0';
                dropdownMenu.addEventListener('transitionend', () => {
                    dropdownMenu.style.transition = '';
                    dropdownMenu.style.display = 'none';
                    dropdownMenu.style.height = '0';
                });
            });
        });
    }

    /**
     * Prevents typing in elements with the 'readonly' class.
     */
    preventTypingOnReadonlyElements() {
        const readonlyElements = document.querySelectorAll('.readonly');
        readonlyElements.forEach(element => {
            element.addEventListener('keydown', (e) => {
                e.preventDefault();
            });
        });
    }
}

new VoicesTheme();
